/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateScheduleRequest,
  InspectionScheduleResponse,
} from '../models/index';
import {
    CreateScheduleRequestFromJSON,
    CreateScheduleRequestToJSON,
    InspectionScheduleResponseFromJSON,
    InspectionScheduleResponseToJSON,
} from '../models/index';

export interface CreateScheduleOperationRequest {
    createScheduleRequest: CreateScheduleRequest;
}

export interface DeleteScheduleRequest {
    id: string;
}

export interface GetAllSchedulesRequest {
    machineId?: string;
}

export interface GetScheduleByIdRequest {
    id: string;
}

export interface SetScheduleActiveRequest {
    id: string;
    active: boolean;
}

export interface UpdateScheduleRequest {
    id: string;
    createScheduleRequest: CreateScheduleRequest;
}

/**
 * 
 */
export class InspectionSchedulesApi extends runtime.BaseAPI {

    /**
     * Creates a new inspection schedule. Validates frequency-specific fields: CUSTOM requires cronExpression, PER_SHIFT requires shiftPattern.
     * Create a new schedule
     */
    async createScheduleRaw(requestParameters: CreateScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        if (requestParameters['createScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'createScheduleRequest',
                'Required parameter "createScheduleRequest" was null or undefined when calling createSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/schedules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScheduleRequestToJSON(requestParameters['createScheduleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new inspection schedule. Validates frequency-specific fields: CUSTOM requires cronExpression, PER_SHIFT requires shiftPattern.
     * Create a new schedule
     */
    async createSchedule(requestParameters: CreateScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.createScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permanently deletes an inspection schedule.
     * Delete a schedule
     */
    async deleteScheduleRaw(requestParameters: DeleteScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently deletes an inspection schedule.
     * Delete a schedule
     */
    async deleteSchedule(requestParameters: DeleteScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScheduleRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all inspection schedules. Optionally filter by machineId.
     * Get all schedules
     */
    async getAllSchedulesRaw(requestParameters: GetAllSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        const queryParameters: any = {};

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/schedules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all inspection schedules. Optionally filter by machineId.
     * Get all schedules
     */
    async getAllSchedules(requestParameters: GetAllSchedulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.getAllSchedulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a single inspection schedule by its identifier.
     * Get schedule by ID
     */
    async getScheduleByIdRaw(requestParameters: GetScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getScheduleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single inspection schedule by its identifier.
     * Get schedule by ID
     */
    async getScheduleById(requestParameters: GetScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.getScheduleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Toggles the active state of a schedule without deletion. When deactivated, future form generation stops but the schedule and its history are preserved. When activated, nextGenerationAt is recalculated.
     * Activate or deactivate a schedule
     */
    async setScheduleActiveRaw(requestParameters: SetScheduleActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setScheduleActive().'
            );
        }

        if (requestParameters['active'] == null) {
            throw new runtime.RequiredError(
                'active',
                'Required parameter "active" was null or undefined when calling setScheduleActive().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/schedules/{id}/activate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Toggles the active state of a schedule without deletion. When deactivated, future form generation stops but the schedule and its history are preserved. When activated, nextGenerationAt is recalculated.
     * Activate or deactivate a schedule
     */
    async setScheduleActive(requestParameters: SetScheduleActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.setScheduleActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an inspection schedule. Recalculates nextGenerationAt based on the new frequency configuration.
     * Update an existing schedule
     */
    async updateScheduleRaw(requestParameters: UpdateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSchedule().'
            );
        }

        if (requestParameters['createScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'createScheduleRequest',
                'Required parameter "createScheduleRequest" was null or undefined when calling updateSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScheduleRequestToJSON(requestParameters['createScheduleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Updates an inspection schedule. Recalculates nextGenerationAt based on the new frequency configuration.
     * Update an existing schedule
     */
    async updateSchedule(requestParameters: UpdateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionScheduleResponse> {
        const response = await this.updateScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
